// extracted by mini-css-extract-plugin
export default {"details":"Sh2Ikr","summary":"YC8SnZ","arrowRight":"ZQSZpU","open":"cPJegY","content":"qetZvY"};